import * as i0 from "@angular/core";
export class RedirectHomeStore {
}
RedirectHomeStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RedirectHomeStore_Factory() { return new RedirectHomeStore(); }, token: RedirectHomeStore, providedIn: "root" });
export var RedirectHomeStoreKeys;
(function (RedirectHomeStoreKeys) {
})(RedirectHomeStoreKeys || (RedirectHomeStoreKeys = {}));
